<template>
  <div class="eta">
    <div class="progress-wrapper">
      <div class="progress" :style="{ 'width': calculateDuration() }">
        <span class="start-time">Started at {{startTime}}</span>
      </div>
      <div class="end"></div>
      <span style="flex: auto"/>
      <span class="estimated-time">ETA {{eta}}</span>
    </div>
    <div class="estimated-arrival-text" v-if="distanceMatrix.duration.text.length > 0">
      <v-btn icon @click="updateDistanceMatrix">
        <i class="material-icons" style="color: var(--text-secondary);">refresh</i>
      </v-btn>
      <small>{{user.name}} is {{distanceMatrix.duration.text}} away</small>
      <span style="flex: auto"/>
      <v-progress-circular indeterminate color="var(--action)" v-if="loadingDistanceMatrix"/>
    </div>
    <small v-else>Locating {{user.name}}</small>
  </div>
</template>

<script>
  import * as moment from 'moment';
  import {store} from "../store";

  export default {
    name: "EstimatedArrival",
    data: () => ({
      currentDuration: 0,
    }),
    computed: {
      distanceMatrix() {
        return this.$store.getters.distanceMatrix;
      },
      loadingDistanceMatrix() {
        return this.$store.getters.loadingDistanceMatrix;
      },
      eta() {
        return moment().add(this.$store.getters.distanceMatrix.duration.value, 'seconds').format('h:mma');
      },
      rightNow() {
        return moment().format('h:mma');
      },
      startTime() {
        return moment(this.tracker.updatedAt).format('h:mma');
      },
      user() {
        return this.$store.getters.user;
      },
      contact() {
        return this.$store.getters.contact;
      },
      tracker() {
        return this.$store.getters.tracker;
      },
    },
    methods: {
      calculateDuration() {
        const eta = moment().add(this.distanceMatrix.duration.value, 'seconds');
        const trackerStarted = moment(this.tracker.updatedAt);
        const fullDuration = eta.diff(trackerStarted, 'seconds');
        const currentDuration = eta.diff(moment(), 'seconds');
        const percentageComplete = (fullDuration - currentDuration) / fullDuration * 100;
        return percentageComplete < 15 ? '15%' : `${percentageComplete.toFixed(0)}%`;
      },
      updateDistanceMatrix() {
        const origins = `${this.user.lat},${this.user.lng}`;
        const destinations = `${this.contact.lat},${this.contact.lng}`;
        this.$store.dispatch('getEstimatedDistance', {
          origins,
          destinations,
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .eta {
    padding: 12px;
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    small {
      color: var(--text-secondary);
      font-style: italic;
    }

    .progress-wrapper {
      width: 100%;
      background-color: var(--background-secondary);
      height: 40px;
      border-radius: 20px;
      position: relative;
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      .progress {
        background-color: var(--action);
        width: 50%;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 12px;

        .start-time {
          font-size: 12px;
          font-style: italic;
        }

      }

      .end {
        height: 0;
        width: 0;
        border-bottom: 40px solid var(--background-secondary);
        border-left: 40px solid transparent;
        margin-left: -40px;
      }

      .estimated-time {
        position: absolute;
        right: 0;
        margin-right: 12px;
        font-style: italic;
        font-size: 12px;
      }
    }

    .estimated-arrival-text {
      display: flex;
      align-items: center;
    }
  }


</style>
